import { HeaderSection } from "@/components/shared/header-section";
import MaxWidthWrapper from "@/components/shared/max-width-wrapper";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import * as m from "@/paraglide/messages";

const FaqData = (m: any) => [
  {
    id: "item-1",
    question: m.faq1(),
    answer: m.faqanswer1(),
  },
  {
    id: "item-2",
    question: m.faq2(),
    answer: m.faqanswer2(),
  },
  {
    id: "item-3",
    question: m.faq3(),
    answer: m.faqanswer3(),
  },
  {
    id: "item-4",
    question: m.faq4(),
    answer: m.faqanswer4(),
  },
];

export function Faq() {
  return (
    <MaxWidthWrapper className=" max-w-4xl">
      <HeaderSection label="FAQ" title={m.frenquently_asked_questions()} />

      <Accordion type="single" collapsible className="my-12 w-full">
        {FaqData(m).map((faqItem) => (
          <AccordionItem key={faqItem.id} value={faqItem.id}>
            <AccordionTrigger>{faqItem.question}</AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground sm:text-[15px]">
              {faqItem.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </MaxWidthWrapper>
  );
}
